import React, { useEffect, useState } from "react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import useHttp from '../../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../../constants/driveglobalfilterinitalstates_bus';
import { useMultivarientVehicleData } from "../context";

const CustomSelectButton = (props) => {
    const { GlobalData, setGlobalData } = useMultivarientVehicleData()

    const { IND, columnfilters, localData, apiEnd, clearFilters = "" } = props;
    const [loadedOption, setLoadedOption] = useState([]);

    const [selectedOptions, setSelectedOptions] = useState([]);
    const [disableInput, setDisableInput] = useState(false);
    const [disableInputValue, setDisableInputValue] = useState("");
    const { isLoading, error, sendReq: fetchData } = useHttp();

    // const appyData = (data) => {
    //     const res_result = data;
    //     const responce = [];
    //     if (res_result.length != 0) {

    //         let newRes = res_result.map(item => ({
    //             id: item?.key?.value,
    //             value: item?.key?.value,
    //             label: item?.key?.value,
    //         }));
    //         responce.push(...newRes)

    //     }
    //     setLoadedOption((preState) => [...responce]);
    //     setSelectedOptions((preState) => []);
    // }

const appyData = (data) => {
    const buckets = data?.unique_vehicles?.buckets || [];
    const responce = [];

    if (buckets.length !== 0) {
        const newRes = buckets.map(item => ({
            id: item?.key?.value,
            value: item?.key?.value,
            label: item?.key?.value
        }));
        responce.push(...newRes);
    }

    setLoadedOption(responce);
    setSelectedOptions([]);
};

    useEffect(() => {

        fetchData({ url: API_URL_MAIN + `ace_multivarient/${apiEnd}`, body: { IND, filterdata: { ...localData } } }, appyData)

    }, [localData.CITY, apiEnd])

    function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
        if (!value) {
            return placeholderButtonLabel || "Select...";
        }
        if (!value.label) {
            return "Select...";
        }

        return value.label;
    }


    function onChange(selectedOption, event) {
        if (!selectedOption || selectedOption.value === "") {
            setSelectedOptions(null);
            props.updateFilter(null, IND);
            return;
        }

        setSelectedOptions(selectedOption);
        props.updateFilter(selectedOption, IND);
    }

    return (
        <>
            <span className="select_col_title_bus">{props.lable}</span>
            {(disableInput) ?
                <input autoComplete="off" className="top-filter filter-col" value={disableInputValue} disabled />
                :
                <ReactMultiSelectCheckboxes className="react-select-container" classNamePrefix="react-select"
                    style={{ dropdownButton: { width: "100%" } }}
                    options={[...loadedOption]}
                    placeholderButtonLabel={props.lable}
                    isMulti={false}
                    getDropdownButtonLabel={getDropdownButtonLabel}
                    value={selectedOptions}
                    onChange={onChange}
                    setState={setSelectedOptions}
                    disabled={true}
                />
            }
        </>
    )
}

export default CustomSelectButton;
